import { AddressLinkType } from 'Modules'

import CopyIcon from 'component/button/copy-icon'
import LinkAddress from 'component/link/link-address'

/** Scan link of an address / tx hash with a quiet copy icon next to it */
const LinkAddressCopy = ({
  address,
  type = 'address',
  max = 8,
}: {
  address?: string | null
  type?: AddressLinkType
  max?: number
}) => {
  if (!address) return <>-</>
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      <LinkAddress address={address} type={type} max={max} />
      <CopyIcon text={address} />
    </span>
  )
}

export default LinkAddressCopy
